var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OuterCasing',[_vm._v(" "+_vm._s(/* 组合一些全局的组件，比如 loading、notify */)+" "),_c('LoadingComponents'),_c('ComponentOuterCasing',{style:(_vm.indexStyle)},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }